export default [
    {
        name: 'warehouse.uplifts.index',
        path: '/warehouse/uplifts',
        component: () => import("@/views/modules/warehouse/uplifts/List.vue"),
    },
    {
        name: 'warehouse.uplifts.show',
        path: '/warehouse/uplifts/:upliftLineId',
        component: () => import("@/views/modules/warehouse/uplifts/Received.vue"),
    },
    {
        name: 'warehouse.uplifts.update',
        path: '/warehouse/uplifts/update',
        component: () => import("@/views/modules/warehouse/uplifts/UpdateSingle.vue"),
    },
    {
        name: 'warehouse.uplifts.complete',
        path: '/warehouse/uplifts/complete',
        component: () => import("@/views/modules/warehouse/uplifts/UpdateMulti.vue"),
    }


]
